<div class="row mb-3">
  <div class="col-xl-12">

    <button class="btn btn-primary">ค้นหา</button>
  </div>
</div>
<div class="row mb-3">
  <div class="col-xl-12">
    <div class="table-responsive">
      <!--      <table class="table table-striped">-->
      <!--        <thead class="text-center">-->
      <!--        <tr>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>ลำดับ</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle">สถานะ</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>เลขที่คำร้อง</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>แหล่งข้อมูล</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>-->
      <!--            วันที่เริ่มใช้หน่วยบริการ-->
      <!--          </th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>-->
      <!--            เลขประจำตัวประชาชน<br />(ผู้ขอลงทะเบียน)-->
      <!--          </th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>ชื่อนามสกุล<br />(ผู้ขอลงทะเบียน)-->
      <!--          </th>-->
      <!--          <th scope="col" colspan="4" class="align-middle" nowrap>เครือข่ายหน่วยบริการเดิม-->
      <!--          </th>-->
      <!--          <th scope="col" colspan="4" class="align-middle" nowrap>เครือข่ายหน่วยบริการสิทธิ ณ-->
      <!--            ปัจจุบัน-->
      <!--          </th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>ประเภทการลงทะเบียน</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>ผู้บันทึกข้อมูล</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>หน่วยงานบันทึกข้อมูล</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>-->
      <!--            จังหวัดหน่วยงานบันทึกข้อมูล-->
      <!--          </th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>ประเภทการยื่นคำร้อง</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>ประเภทการพักอาศัย</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>เลขประจำตัวประชาชน-->
      <!--            (ผู้รับมอบอำนาจ)-->
      <!--          </th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>ชื่อ-นามสกุล-->
      <!--            (ผู้รับมอบอำนาจ)-->
      <!--          </th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>สิทธิหลัก</th>-->
      <!--          <th scope="col" rowspan="2" class="align-middle" nowrap>ประเภทสิทธิย่อย</th>-->
      <!--        </tr>-->
      <!--        <tr class="table-sm">-->
      <!--          <th scope="col" class="align-middle" nowrap>จังหวัดที่ลงทะเบียน</th>-->
      <!--          <th scope="col" class="align-middle" nowrap>หน่วยบริการปฐมภูมิ</th>-->
      <!--          <th scope="col" class="align-middle" nowrap>หน่วยบริการประจำ</th>-->
      <!--          <th scope="col" class="align-middle" nowrap>หน่วยบริการที่รับการส่งต่อ</th>-->
      <!--          <th scope="col" class="align-middle" nowrap>จังหวัดที่ลงทะเบียน</th>-->
      <!--          <th scope="col" class="align-middle" nowrap>หน่วยบริการปฐมภูมิ</th>-->
      <!--          <th scope="col" class="align-middle" nowrap>หน่วยบริการประจำ</th>-->
      <!--          <th scope="col" class="align-middle" nowrap>หน่วยบริการที่รับการส่งต่อ</th>-->
      <!--        </tr>-->
      <!--        </thead>-->
      <!--        <tbody class="table-group-dividerx">-->
      <!--        <tr>-->
      <!--&lt;!&ndash;          <td nowrap class="text-center">&ndash;&gt;-->
      <!--&lt;!&ndash;            {!{pageData.getSize() * pageData.getNumber() + item_index + 1}!}&ndash;&gt;-->
      <!--&lt;!&ndash;            {page:sequence(pageData, item_index)}&ndash;&gt;-->
      <!--&lt;!&ndash;          </td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>todo</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{item.getId()}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{item.getRegisterSource().getDescription()}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{app:formatLocalDateTime(item.getEffectiveDate(), "dd/MM/yyyy")}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{item.pid}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>&ndash;&gt;-->
      <!--&lt;!&ndash;            {#if item.personalData}&ndash;&gt;-->
      <!--&lt;!&ndash;            {item.personalData.fullName}&ndash;&gt;-->
      <!--&lt;!&ndash;            {/if}&ndash;&gt;-->
      <!--&lt;!&ndash;          </td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>&ndash;&gt;-->
      <!--&lt;!&ndash;            {#if item.oldPurchaseProvince}&ndash;&gt;-->
      <!--&lt;!&ndash;            {item.oldPurchaseProvince.name}&ndash;&gt;-->
      <!--&lt;!&ndash;            {/if}&ndash;&gt;-->
      <!--&lt;!&ndash;          </td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{hospital:fullName(item.oldHsub)}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{hospital:fullName(item.oldHmain)}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{hospital:fullName(item.oldHmainOp)}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>&ndash;&gt;-->
      <!--&lt;!&ndash;            {#if item.regProvince}&ndash;&gt;-->
      <!--&lt;!&ndash;            {item.regProvince.name}&ndash;&gt;-->
      <!--&lt;!&ndash;            {/if}&ndash;&gt;-->
      <!--&lt;!&ndash;          </td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{hospital:fullName(item.hsub)}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{hospital:fullName(item.hmain)}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{hospital:fullName(item.hmainOp)}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>&ndash;&gt;-->
      <!--&lt;!&ndash;            {#if item.regType}&ndash;&gt;-->
      <!--&lt;!&ndash;            {item.regType.description}&ndash;&gt;-->
      <!--&lt;!&ndash;            {/if}&ndash;&gt;-->
      <!--&lt;!&ndash;          </td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>&ndash;&gt;-->
      <!--&lt;!&ndash;            {#if item.createPerson}&ndash;&gt;-->
      <!--&lt;!&ndash;            {item.createPerson.fullName}&ndash;&gt;-->
      <!--&lt;!&ndash;            {/if}&ndash;&gt;-->
      <!--&lt;!&ndash;          </td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{hospital:fullName(item.createHospital)}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{hospital:provinceName(item.createHospital)}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>todo</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>todo</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>todo</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>todo</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{rights:mainInsclFullName(item.mainInscl)}</td>&ndash;&gt;-->
      <!--&lt;!&ndash;          <td nowrap>{rights:subInsclFullName(item.subInscl)}</td>&ndash;&gt;-->
      <!--        </tr>-->
      <!--        </tbody>-->
      <!--      </table>-->
    </div>
  </div>
</div>
